import { createFileRoute } from '@tanstack/react-router'

import { BeneficiariesPageSkeleton } from '#/modules/health/front-office/beneficiaries-page/beneficiaries-page-skeleton.tsx'
import { BeneficiariesPage } from '#/modules/health/front-office/beneficiaries-page/beneficiaries-page.tsx'

export const Route = createFileRoute('/(customer)/_shell/health-insurance-v2/beneficiaries')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(context.trpc.muta.getMutaBeneficiariesInfos.queryOptions()),
  pendingComponent: BeneficiariesPageSkeleton,
  pendingMs: 150,
  component: BeneficiariesPage,
})
